import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'momentPipe'
})
export class MomentPipe implements PipeTransform {
  transform(value: Date|moment.Moment, ...args: any[]): any {
    let [format] = args;
    if(!args[1]){
      args[1] = "YYYY-MM-DD HH:mm:ss";
    }
    return moment(value,args[1]).format(args[0]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/momentPipe.ts